import { createAction, props } from "@ngrx/store";
import { Report } from "../../entities";

export enum ReportsAction {
  ClearAll = "[REPORTS] Clear all reports",
  FetchReports = "[REPORTS] Fetch reports",
  SetReports = "[REPORTS] Set reports",
  DeleteReport = "[REPORTS] Delete report",
}

export const clearAll = createAction(ReportsAction.ClearAll);
export const setReports = createAction(ReportsAction.SetReports, props<{ reports: Array<Report> }>());
export const fetchReports = createAction(ReportsAction.FetchReports, props<{ retailerIds: number[] }>());
export const deleteReport = createAction(ReportsAction.DeleteReport, props<{ id: string; retailerId: number }>());
